enum BaseFilterCodeEnum {
  CreatedFrom = 'created-from',
  CreatedTo = 'created-to',
}

export default BaseFilterCodeEnum;
